<template>
  <!-- Main content -->
    <!-- Info boxes -->
    <div class="row">
      <div class="box">
        <div class="box-header with-border">
          <div class="col-xs-12">
            <div class="box-header">
              <div class="col-xs-12 col-md-6">
                <h3 class="box-title">品牌成交量前五名</h3>
                <br><br>
                <div class="box-body p-0">
                  <div class="col-xs-12 text-center" v-if="topOrderAmount.brand">
                    <canvas id="today-brand-top"></canvas>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <h3 class="box-title">店家成交量前五名</h3>
                <br><br>
                <div class="box-body p-0">
                  <div class="col-xs-12 text-center" v-if="topOrderAmount.store">
                    <canvas id="today-store-top"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header with-border">
            <div class="col-xs-12 text-right pull-right">
              <div class="form-group input-group time-box pull-right">
                <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
                <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
                <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
                <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
                <span class="input-group-btn">
                  <button class="btn btn-default submit-btn btn-search" type="button"
                          id="search" style="height: 72px" @click="getShopperStatus()">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <h3 class="box-title">當日使用者註冊狀態</h3><br><br>
              <div class="box-body p-0">
                <div class="col-xs-12">
                  <canvas class="line-canvas" id="today-shopper"></canvas>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <h3 class="box-title">累積使用者註冊狀態</h3><br><br>
              <div class="box-body p-0">
                <div class="col-xs-12">
                  <canvas class="line-canvas" id="total-shopper"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header with-border">
            <div class="col-xs-12">
              <div class="col-sm-6 text-left">
                <div class="form-group form-inline w-auto" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo'">
                  <select class="form-control h-38" v-model="brandSelect">
                    <option value="0" v-if="roleType !== 10">== 品牌 ==</option>
                    <option v-for="brand in brandBrief" :value="brand.value">
                      {{brand.label}}
                    </option>
                  </select>
                </div>
                <div class="form-group form-inline w-auto" v-if="brandSelect !== 0 && brandSelect !== '0' && storeBrief.length > 1 && $route.name !== 'storeInfo'">
                  <select class="form-control h-38" v-model="storeSelect">
                    <option value="0">== 門市 ==</option>
                    <option v-for="store in storeBrief" :value="store.value">
                      {{store.label}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6 text-right pull-right">
                <div class="form-group input-group time-box pull-right">
                  <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
                  <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
                  <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
                  <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
                  <span class="input-group-btn">
                  <button class="btn btn-default submit-btn btn-search" type="button"
                          id="search2" style="height: 72px" @click="getShopperStatus()">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <h3 class="box-title">當日不重複之使用者行為</h3><br><br>
              <div class="box-body p-0">
                <div class="col-xs-12">
                  <canvas class="line-canvas" id="shopper-active"></canvas>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <h3 class="box-title">交易訂單統計<span class="text-red text-12" v-if="brandSelect === 0 || brandSelect === '0'">(請選擇品牌或店家)</span></h3><br><br>
              <div class="box-body p-0">
                <div class="col-xs-12">
                  <canvas class="line-canvas" id="order-transactions"></canvas>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <h3 class="box-title">交易金額統計<span class="text-red text-12" v-if="brandSelect === 0 || brandSelect === '0'">(請選擇品牌或店家)</span></h3><br><br>
              <div class="box-body p-0">
                <div class="col-xs-12">
                  <canvas class="line-canvas" id="money-transactions"></canvas>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <h3 class="box-title">交易數量統計<span class="text-red text-12" v-if="brandSelect === 0 || brandSelect === '0'">(請選擇品牌或店家)</span></h3><br><br>
              <div class="box-body p-0">
                <div class="col-xs-12">
                  <canvas class="line-canvas" id="amount-transactions"></canvas>
                </div>
              </div>
            </div>
            <div class="col-xs-12">
              <h3 class="box-title">拒單原因統計<span class="text-red text-12" v-if="brandSelect === 0 || brandSelect === '0'">(請選擇品牌或店家)</span></h3><br><br>
              <div class="box-body p-0">
                <div class="col-xs-12">
                  <canvas class="line-canvas" id="rejected-orders"></canvas>
                </div>
                <div class="col-xs-12" style="overflow: scroll; max-height: 500px;" v-if="rejectedOrderList">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable" v-if="rejectedOrderList.length">
                    <thead>
                      <tr>
                        <th class="th-fit">日期</th>
                        <th>拒單原因 (狀態)</th>
                        <th>筆數</th>
                        <th>杯數</th>
                        <th>金額</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="even" role="row" v-for="(reject, index) in rejectedOrderList">
                        <td :rowspan="reject.reasonAmount" v-if="reject.date">{{getMonthDay(reject.date)}}</td>
                        <td>{{reject.reject_reason}} ({{reject.reject_status}})</td>
                        <td>{{reject.order_count}} 筆</td>
                        <td>{{reject.item_count}} 杯</td>
                        <td>{{reject.money}} 元</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-xs-12 text-right" v-if="rejectedOrderList">
                  <div v-if="rejectedOrderList.length">
                    <h6>共損失 {{total.orderCount}} 筆訂單</h6>
                    <h6> {{total.itemCount}} 杯飲料</h6>
                    <h6> {{total.money}} 元收入</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header with-border">
            <div class="col-xs-12">
              <div class="col-sm-6 text-left">
                <div class="form-group form-inline w-auto" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo'">
                  <select class="form-control h-38" v-model="brandSelect">
                    <option value="0" v-if="roleType !== 10">== 品牌 ==</option>
                    <option v-for="brand in brandBrief" :value="brand.value">
                      {{brand.label}}
                    </option>
                  </select>
                </div>
                <div class="form-group form-inline w-auto" v-if="brandSelect !== 0 && brandSelect !== '0' && storeBrief.length > 1 && $route.name !== 'storeInfo'">
                  <select class="form-control h-38" v-model="storeSelect">
                    <option value="0">== 門市 ==</option>
                    <option v-for="store in storeBrief" :value="store.value">
                      {{store.label}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 text-right pull-right">
                <div class="form-group input-group time-box pull-right">
                  <date-time-picker :date="menuTime.week" :option="dateoption" :limit="weekLimit"></date-time-picker>
                  <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
                  <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
                  <span class="input-group-btn">
                  <button class="btn btn-default submit-btn btn-search" type="button"
                          id="search3" style="height: 36px" @click="setProductSale()">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
                </div>
              </div>
            </div>
            <h3 class="box-title">銷售量統計(以週期計算)<span class="text-red text-12" v-if="brandSelect === 0 || brandSelect === '0'">(請選擇品牌或店家)</span></h3><br><br>
            <div class="box-body p-0" style="min-height: 100px;" v-if="productSaleList.length">
              <div class="col-xs-12" v-if="productSaleList.length">
                <!--<div v-for="(p, index) in productSaleList">{{p.name}}</div>-->
                <div class="col-xs-12 text-center col-md-4 col-lg-3" v-if="productSaleList[0]">
                  <div><img src="/static/img/crown.png"></div>
                  <h3 class="text-yellow">{{productSaleList[0].name}}</h3>
                </div>
                <div class="col-xs-12 text-center col-md-4 col-lg-3 hidden-xs hidden-sm" v-if="productSaleList[1]">
                  <div><img src="/static/img/crown.png"></div>
                  <h3 class="text-yellow">{{productSaleList[1].name}}</h3>
                </div>
                <div class="col-xs-12 text-center col-md-4 col-lg-3 hidden-xs hidden-sm" v-if="productSaleList[2]">
                  <div><img src="/static/img/crown.png"></div>
                  <h3 class="text-yellow">{{productSaleList[2].name}}</h3>
                </div>
                <div class="col-xs-12 text-center col-md-4 col-lg-3 visible-lg-block" v-if="productSaleList[3]">
                  <div><img src="/static/img/crown.png"></div>
                  <h3 class="text-yellow">{{productSaleList[3].name}}</h3>
                </div>
                <div class="col-xs-12">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <tbody>
                    <tr class="even" role="row" v-for="(product, index) in productSaleList" v-if="index + 1 <= 10">
                      <td>
                        No.{{index + 1}}
                      </td>
                      <td>
                        <span>{{product.name}}</span>
                      </td>
                      <td>
                        {{product.amount}} 杯
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <!--<canvas class="line-canvas" id="product-sale"></canvas>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- /.content -->
</template>

<script>
import $ from 'jquery'
import Chart from 'chart.js'
import moment from 'moment'
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
var todayChart, totalChart, shopperActiveChart, transactionsOrderChart, transactionsMoneyChart, transactionsAmountChart, rejectedChart
var rejectStatus = 120
var systemRStatus = 121
var storeCancelStatus = 122
var orderDestroyStatus = 140
export default {
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      productSaleList: [],
      isMobile: false,
      roleType: 99,
      info: '',
      usersInfo: '',
      disAmount: 0,
      ordersAmount: 0,
      todaySuccess: 0,
      errorAmount: 0,
      shoppersAmount: 0,
      topOrderAmount: {},
      brandSelect: 0,
      storeSelect: 0,
      brandBrief: [],
      storeBrief: [],
      // topBrand
      topBLabels: [],
      topBData: [],
      // topStore
      topSLabels: [],
      topSData: [],
      // shopperStatus
      labels: [],
      shopperState: {
        today: {
          total: [],
          certify: [],
          fb: [],
          google: []
        },
        total: {
          total: [],
          certify: [],
          fb: [],
          google: []
        }
      },
      // shopperActive
      activeLabels: [],
      shopperActive: {
        cr: [],
        cancel: [],
        search: [],
        read: [],
        feedback: []
      },
      // transactions
      transactionLabels: [],
      transactions: {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      },
      // reject
      rejectedOrderList: [],
      rejectedLabels: [],
      rejected: {
        120: [],
        121: [],
        122: [],
        140: []
      },
      // productSale
      productSaleLabels: [],
      productSaleData: [],
      // date
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: moment().add(1, 'days').format('YYYY-MM-DD')
        },
        week: {
          time: moment().add(-1, 'weeks').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      weekLimit: [
        {
          type: 'fromto',
          to: moment().add(-1, 'weeks').day(7).format('YYYY-MM-DD')
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    total () {
      let tOrder = 0
      let tItem = 0
      let tMoney = 0
      for (var i = 0; i < this.rejectedOrderList.length; i++) {
        tOrder = tOrder + this.rejectedOrderList[i].order_count
        tItem = tItem + this.rejectedOrderList[i].item_count
        tMoney = tMoney + this.rejectedOrderList[i].money
      }
      return {
        orderCount: tOrder,
        itemCount: tItem,
        money: tMoney
      }
    }
    /*,
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
    */
  },
  created () {
    var date = new Date()
    var y = date.getFullYear()
    var m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    this.menuTime.start.time = moment(firstDay).format('YYYY-MM-DD')
    this.fixedH()
    let roleType = parseInt(this.getRoleType, 10)
    this.roleType = roleType
    if (roleType === 99) {
      this.initSystem()
      this.getBrandBrief()
      this.getShopperStatus()
    } else if (roleType === 30) this.getBrandBrief()
    else if (roleType === 10) this.getBrandBrief()
  },
  methods: {
    initSystem () {
      var self = this
      var url = '/statistic/matcher'
      this.topBLabels = []
      this.topBData = []
      this.topSLabels = []
      this.topSData = []
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const info = self.info = response.data.platform_statistic
          self.ordersAmount = info.order_amount.total
          self.topOrderAmount = info.top_order_amount.total
          for (var b = 0; b < self.topOrderAmount.brand.length; b++) {
            self.topBLabels.push(self.topOrderAmount.brand[b].brand_name)
            self.topBData.push(self.topOrderAmount.brand[b].amount)
          }
          for (var s = 0; s < self.topOrderAmount.store.length; s++) {
            self.topSLabels.push(self.topOrderAmount.store[s].store_name)
            self.topSData.push(self.topOrderAmount.store[s].amount)
          }
          // state = 130 = 成交
          if (info.trade_money.today[130]) self.todaySuccess = info.trade_money.today[130].money
          // state = 110 = 已接單
          self.errorAmount = info.abnormal_amount.total
          self.showTopChart()
        }
      })
      var usersUrl = '/statistic/shopper'
      this.getDataH('get', usersUrl, null, function (response) {
        if (response.data.status === 200) {
          const usersInfo = self.usersInfo = response.data.shopper_statistic
          self.shoppersAmount = usersInfo.shopper_amount.total.active
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          var brandIds = ''
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            brandIds = brandIds + bList[i].brand_id + ','
          }
          brandIds = brandIds.slice(0, -1)
          if (self.roleType === 30) self.initBrand(brandIds)
          else if (self.roleType === 10) self.getStoreBrief(brandIds)
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          var storeIds = ''
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            storeIds = storeIds + sList[i].store_id + ','
          }
          storeIds = storeIds.slice(0, -1)
          if (storeIds) self.initStore(storeIds)
        }
      })
    },
    initBrand (brandIds) {
      var self = this
      var url = '/statistic/brand?brand_ids=' + brandIds
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const info = self.info = response.data.brand_statistic
          self.ordersAmount = info.order_amount.total
          self.topOrderAmount = info.top_order_amount.total
          // state = 130 = 成交
          if (info.trade_money.today[130]) self.todaySuccess = info.trade_money.today[130].money
          // state = 120 = 店家退訂
          // state = 121 = 系統退訂
          // state = 122 = 店家幫使用者取消
          // state = 39 = 揪團失敗
          let disAmount = 0
          if (info.trade_money.today[120]) disAmount = disAmount + info.trade_money.today[120].money
          if (info.trade_money.today[121]) disAmount = disAmount + info.trade_money.today[121].money
          if (info.trade_money.today[122]) disAmount = disAmount + info.trade_money.today[122].money
          if (info.trade_money.today[39]) disAmount = disAmount + info.trade_money.today[39].money
          self.disAmount = disAmount
          // state = 110 = 已接單
          self.errorAmount = info.abnormal_amount.total
        }
      })
    },
    initStore (storeIds) {
      var self = this
      var url = '/statistic/store?store_ids=' + storeIds
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const info = self.info = response.data.store_statistic
          // state = 130 = 成交
          if (info.trade_money.today[130]) self.todaySuccess = info.trade_money.today[130].money
          // state = 120 = 店家退訂
          // state = 121 = 系統退訂
          // state = 122 = 店家幫使用者取消
          // state = 39 = 揪團失敗
          let disAmount = 0
          if (info.trade_money.today[120]) disAmount = disAmount + info.trade_money.today[120].money
          if (info.trade_money.today[121]) disAmount = disAmount + info.trade_money.today[121].money
          if (info.trade_money.today[122]) disAmount = disAmount + info.trade_money.today[122].money
          if (info.trade_money.today[39]) disAmount = disAmount + info.trade_money.today[39].money
          self.disAmount = disAmount
          // state = 110 = 已接單
          self.errorAmount = info.abnormal_amount.total
        }
      })
    },
    getShopperStatus () {
      this.labels = []
      this.shopperState = {
        today: {
          total: [],
          certify: [],
          fb: [],
          google: []
        },
        total: {
          total: [],
          certify: [],
          fb: [],
          google: []
        }
      }
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = '/statistic/shopperStatus?start_date=' + data.start_time + '&end_date=' + data.end_time
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.shopper_status_list
          for (var i in sList) {
            self.labels.push(moment(sList[i].date, 'YYYY-MM-DD').format('MM/DD'))
            self.shopperState.today.total.push(sList[i].total_day)
            self.shopperState.today.certify.push(sList[i].verified_day)
            self.shopperState.today.fb.push(sList[i].from_facebook_day)
            self.shopperState.today.google.push(sList[i].from_google_day)
            self.shopperState.total.total.push(sList[i].total_accum)
            self.shopperState.total.certify.push(sList[i].verified_accum)
            self.shopperState.total.fb.push(sList[i].from_facebook_accum)
            self.shopperState.total.google.push(sList[i].from_google_accum)
          }
          self.getShopperActivity()
          self.showShopperChart()
        }
      })
    },
    getShopperActivity (type, id) {
      this.activeLabels = []
      this.shopperActive = {
        cr: [],
        cancel: [],
        search: [],
        read: [],
        feedback: []
      }
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = ''
      if (type === 'brand') url = '/statistic/brandShopperActivity?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_id=' + id
      else if (type === 'store') url = '/statistic/storeShopperActivity?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_id=' + id
      else url = '/statistic/shopperActivity?start_date=' + data.start_time + '&end_date=' + data.end_time
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var aList = response.data.shopper_activity_list
          for (var i in aList) {
            if (!type) {
              self.activeLabels.push(moment(aList[i].date, 'YYYY-MM-DD').format('MM/DD'))
              self.shopperActive.cr.push(aList[i].create_order)
              self.shopperActive.cancel.push(aList[i].cancel_order)
              self.shopperActive.search.push(aList[i].search_store)
              self.shopperActive.read.push(aList[i].read_notification)
              self.shopperActive.feedback.push(aList[i].create_feedback)
            } else {
              self.activeLabels.push(moment(aList[i][0].date, 'YYYY-MM-DD').format('MM/DD'))
              self.shopperActive.cr.push(aList[i][0].create_order)
              self.shopperActive.cancel.push(aList[i][0].cancel_order)
              self.shopperActive.search.push(aList[i][0].search_store)
              self.shopperActive.read.push(aList[i][0].read_notification)
              self.shopperActive.feedback.push(aList[i][0].create_feedback)
            }
          }
          self.showShopperActiveChart()
          if ((self.brandSelect !== 0 || self.brandSelect !== '0') && (self.storeSelect === 0 || self.storeSelect === '0')) self.getTransactions('brand', self.brandSelect)
          else if (self.storeSelect !== 0 && self.storeSelect !== '0') self.getTransactions('store', self.storeSelect)
          else self.getTransactions(type, id)
        }
      })
    },
    getTransactions (type, id) {
      this.transactionLabels = []
      this.transactions = {
        order_count_accum: [],
        order_count_day: [],
        order_count_day_normal: [],
        order_count_day_group: [],
        money_accum: [],
        money_accum_mean: [],
        money_day: [],
        money_day_normal: [],
        money_day_group: [],
        money_day_mean: [],
        item_count_accum: [],
        item_count_accum_mean: [],
        item_count_day: [],
        item_count_day_normal: [],
        item_count_day_group: [],
        item_count_day_mean: []
      }
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = ''
      if (type === 'brand') url = '/statistic/brandTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id
      else if (type === 'store') url = '/statistic/storeTransactions?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + id
      if (this.brandSelect === 0 || this.brandSelect === '0') {
        this.showTransactionsChart(type)
        this.showRejectedChart('nodata')
      } else {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var tList = response.data.statistics
            var info
            for (var i in tList) {
              if (type === 'brand') {
                info = 'brand_info'
              } else if (type === 'store') {
                info = 'store_info'
              }
              self.transactionLabels.push(moment(i, 'YYYY-MM-DD').format('MM/DD'))
              self.transactions.order_count_accum.push(tList[i][info][id].order_count_accum)
              self.transactions.order_count_day.push(tList[i][info][id].order_count_day)
              self.transactions.order_count_day_normal.push(tList[i][info][id].order_count_day_normal)
              self.transactions.order_count_day_group.push(tList[i][info][id].order_count_day_group)
              self.transactions.money_accum.push(tList[i][info][id].money_accum)
              self.transactions.money_accum_mean.push(tList[i][info][id].money_accum_mean)
              self.transactions.money_day.push(tList[i][info][id].money_day)
              self.transactions.money_day_normal.push(tList[i][info][id].money_day_normal)
              self.transactions.money_day_group.push(tList[i][info][id].money_day_group)
              self.transactions.money_day_mean.push(tList[i][info][id].money_day_mean)
              self.transactions.item_count_accum.push(tList[i][info][id].item_count_accum)
              self.transactions.item_count_accum_mean.push(tList[i][info][id].item_count_accum_mean)
              self.transactions.item_count_day.push(tList[i][info][id].item_count_day)
              self.transactions.item_count_day_normal.push(tList[i][info][id].item_count_day_normal)
              self.transactions.item_count_day_group.push(tList[i][info][id].item_count_day_group)
            }
            if ((self.brandSelect !== 0 || self.brandSelect !== '0') && (self.storeSelect === 99 || self.storeSelect === '99')) self.getRejected('brand', self.brandSelect)
            else if (self.storeSelect !== 0 && self.storeSelect !== '0') self.getRejected('store', self.storeSelect)
            else self.getRejected(type, id)
            self.showTransactionsChart(type)
          }
        })
      }
    },
    getRejected (type, id) {
      this.rejectedLabels = []
      this.rejected = {
        120: [],
        121: [],
        122: [],
        140: []
      }
      this.rejectedOrderList = []
      var self = this
      var data = {
        start_time: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_time: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = ''
      if (type === 'brand') url = '/statistic/brandRejectedOrders?start_date=' + data.start_time + '&end_date=' + data.end_time + '&brand_ids=' + id
      else if (type === 'store') url = '/statistic/storeRejectedOrders?start_date=' + data.start_time + '&end_date=' + data.end_time + '&store_ids=' + id
      if (this.brandSelect === 0 || this.brandSelect === '0') this.showRejectedChart(type)
      else {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var rList = response.data.rejected_order
            var info
            for (var i in rList) {
              if (type === 'brand') {
                info = 'brand_info'
              } else if (type === 'store') {
                info = 'store_info'
              }
              for (let n = 0; n < rList[i][info].length; n++) {
                if (n === 0) {
                  rList[i][info][n]['date'] = i
                  rList[i][info][n]['reasonAmount'] = rList[i][info].length
                }
                self.rejectedOrderList.push(rList[i][info][n])
              }
              self.rejectedLabels.push(moment(i, 'YYYY-MM-DD').format('MM/DD'))
              let rejectCount = rList[i][info].filter(function (e, i, o) {
                return e.reject_status === rejectStatus
              })
              let systemRCount = rList[i][info].filter(function (e, i, o) {
                return e.reject_status === systemRStatus
              })
              let storeCancelCount = rList[i][info].filter(function (e, i, o) {
                return e.reject_status === storeCancelStatus
              })
              let orderDestroy = rList[i][info].filter(function (e, i, o) {
                return e.reject_status === orderDestroyStatus
              })
              let rejectTotal = 0
              let systemRTotal = 0
              let storeCancelTotal = 0
              let orderDestroyTotal = 0
              for (let j = 0; j < rejectCount.length; j++) {
                rejectTotal = rejectTotal + rejectCount[j].order_count
              }
              for (let k = 0; k < systemRCount.length; k++) {
                systemRTotal = systemRTotal + systemRCount[k].order_count
              }
              for (let l = 0; l < storeCancelCount.length; l++) {
                storeCancelTotal = storeCancelTotal + storeCancelCount[l].order_count
              }
              for (let m = 0; m < orderDestroy.length; m++) {
                orderDestroyTotal = orderDestroyTotal + orderDestroy[m].order_count
              }
              self.rejected[rejectStatus].push(rejectTotal)
              self.rejected[systemRStatus].push(systemRTotal)
              self.rejected[storeCancelStatus].push(storeCancelTotal)
              self.rejected[orderDestroyStatus].push(orderDestroyTotal)
            }
            self.showRejectedChart()
            if ((self.brandSelect !== 0 || self.brandSelect !== '0') && (self.storeSelect === 0 || self.storeSelect === '0')) self.getProductSale('brand', self.brandSelect)
            else if (self.storeSelect !== 0 && self.storeSelect !== '0') self.getProductSale('store', self.storeSelect)
            else self.getProductSale(type, id)
          }
        })
      }
    },
    setProductSale () {
      if ((this.storeSelect === 0 || this.storeSelect === '0') && this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getProductSale('brand', this.brandSelect)
      } else if (this.storeSelect !== 0 && this.storeSelect !== '0') {
        this.getProductSale('store', this.storeSelect)
      } else {
        this.productSaleList = []
      }
    },
    getProductSale (type, id) {
      this.productSaleList = []
      var self = this
      var searchWeek = moment(self.menuTime.week.time, 'YYYY-MM-DD').week()
      var data = {
        year: moment(this.menuTime.week.time, 'YYYY-MM-DD').format('YYYY'),
        start_week: searchWeek,
        end_week: searchWeek
      }
      var url = ''
      if (type === 'brand') url = '/statistic/brandProductSale?year=' + data.year + '&start_week=' + data.start_week + '&end_week=' + data.end_week + '&brand_id=' + id
      else if (type === 'store') url = '/statistic/storeProductSale?year=' + data.year + '&start_week=' + data.start_week + '&end_week=' + data.end_week + '&store_id=' + id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (response.data.product_sale_list && response.data.product_sale_list[searchWeek]) self.productSaleList = response.data.product_sale_list[searchWeek][id]
        }
      })
    },
    showTopChart () {
      this.$nextTick(() => {
        var ctx = document.getElementById('today-brand-top').getContext('2d')
        var config = {
          type: 'pie',
          data: {
            datasets: [{
              data: this.topBData,
              backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
            }],
            // These labels appear in the legend and in the tooltips when hovering different arcs
            labels: this.topBLabels
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        new Chart(ctx, config) // eslint-disable-line no-new

        var ctx2 = document.getElementById('today-store-top').getContext('2d')
        var config2 = {
          type: 'pie',
          data: {
            datasets: [{
              data: this.topSData,
              backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
            }],
            // These labels appear in the legend and in the tooltips when hovering different arcs
            labels: this.topSLabels
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        new Chart(ctx2, config2) // eslint-disable-line no-new
      })
    },
    showShopperChart () {
      this.$nextTick(() => {
        if (typeof todayChart !== 'undefined') {
          todayChart.destroy()
        }
        if (typeof totalChart !== 'undefined') {
          totalChart.destroy()
        }
        // today shopper
        var ctx = document.getElementById('today-shopper').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.labels,
            datasets: [{
              label: '當日註冊人數',
              fill: false,
              borderColor: '#00a65a',
              pointBackgroundColor: '#00a65a',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.today.total
            }, {
              label: '當日的通過手機驗證人數',
              borderColor: '#f39c12',
              pointBackgroundColor: '#f39c12',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.today.certify
            }, {
              label: '當日Facebook註冊人數',
              borderColor: '#00c0ef',
              pointBackgroundColor: '#00c0ef',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.today.fb
            }, {
              label: '當日Google註冊人數',
              borderColor: '#dd4b39',
              pointBackgroundColor: '#dd4b39',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.today.google
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            /*
            elements: {
              line: {
                tension: 0
              }
            },
            */
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        todayChart = new Chart(ctx, config) // eslint-disable-line no-new

        // total shopper
        var ctx2 = document.getElementById('total-shopper').getContext('2d')
        var config2 = {
          type: 'line',
          data: {
            labels: this.labels,
            datasets: [{
              label: '當日註冊人數',
              fill: false,
              borderColor: '#00a65a',
              pointBackgroundColor: '#00a65a',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.total.total
            }, {
              label: '當日的通過手機驗證人數',
              borderColor: '#f39c12',
              pointBackgroundColor: '#f39c12',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.total.certify
            }, {
              label: '當日Facebook註冊人數',
              borderColor: '#00c0ef',
              pointBackgroundColor: '#00c0ef',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.total.fb
            }, {
              label: '當日Google註冊人數',
              borderColor: '#dd4b39',
              pointBackgroundColor: '#dd4b39',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              data: this.shopperState.total.google
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        totalChart = new Chart(ctx2, config2) // eslint-disable-line no-new
      })
    },
    showShopperActiveChart (type) {
      var datas = []
      if (typeof shopperActiveChart !== 'undefined') {
        shopperActiveChart.destroy()
      }
      if (!type) {
        datas = [{
          label: '當日送出訂單人數',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.cr
        }, {
          label: '當日取消訂單人數',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.cancel
        }, {
          label: '當日以位置查詢店家人數',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.search
        }, {
          label: '有閱讀網頁通知人數',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.read
        }, {
          label: '有送出意見人數',
          borderColor: '#337ab7',
          pointBackgroundColor: '#337ab7',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.feedback
        }]
      } else {
        datas = [{
          label: '當日送出訂單人數',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.cr
        }, {
          label: '當日取消訂單人數',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.shopperActive.cancel
        }]
      }
      this.$nextTick(() => {
        // total shopper
        var ctx = document.getElementById('shopper-active').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.activeLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        shopperActiveChart = new Chart(ctx, config) // eslint-disable-line no-new
      })
    },
    showRejectedChart (type) {
      if (typeof rejectedChart !== 'undefined') {
        rejectedChart.destroy()
      }
      if (type === 'nodata') {
        this.rejectedLabels = []
        this.rejected = {
          120: [],
          121: [],
          122: [],
          140: []
        }
      }
      this.$nextTick(() => {
        var ctx = document.getElementById('rejected-orders').getContext('2d')
        var config = {
          type: 'bar',
          data: {
            labels: this.rejectedLabels,
            datasets: [{
              label: '店家退訂',
              data: this.rejected[rejectStatus],
              backgroundColor: [
                '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a',
                '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a',
                '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a', '#00a65a'
              ]
            }, {
              label: '系統退訂',
              data: this.rejected[systemRStatus],
              backgroundColor: [
                '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12',
                '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12',
                '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12', '#f39c12'
              ]
            }, {
              label: '店家取消',
              data: this.rejected[storeCancelStatus],
              backgroundColor: [
                '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef',
                '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef',
                '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef', '#00c0ef'
              ]
            }, {
              label: '訂單作廢',
              data: this.rejected[orderDestroyStatus],
              backgroundColor: [
                '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39',
                '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39',
                '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39', '#dd4b39'
              ]
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }]
            },
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        rejectedChart = new Chart(ctx, config) // eslint-disable-line no-new
      })
    },
    showTransactionsChart (type) {
      this.$nextTick(() => {
        var datas = [{
          label: '累積訂單數量',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.order_count_accum,
          yAxisID: 'y-axis-2'
        }, {
          label: '當日訂單數量',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.order_count_day,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日一般單數量',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.order_count_day_normal,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日揪團單數量',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.order_count_day_group,
          yAxisID: 'y-axis-1'
        }]
        var datas2 = [{
          label: '累積成交金額',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.money_accum,
          yAxisID: 'y-axis-2'
        }, {
          label: '平均成交金額',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.money_accum_mean,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日成交金額',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.money_day,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日平均成交金額',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.money_day_mean,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日一般單交金額',
          borderColor: '#337ab7',
          pointBackgroundColor: '#337ab7',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.money_day_normal,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日揪團單成交金額',
          borderColor: '#605ca8',
          pointBackgroundColor: '#605ca8',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.money_day_group,
          yAxisID: 'y-axis-1'
        }]
        var datas3 = [{
          label: '累積杯數',
          fill: false,
          borderColor: '#00a65a',
          pointBackgroundColor: '#00a65a',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.item_count_accum,
          yAxisID: 'y-axis-2'
        }, {
          label: '平均杯數',
          borderColor: '#f39c12',
          pointBackgroundColor: '#f39c12',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.item_count_accum_mean,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日杯數',
          borderColor: '#00c0ef',
          pointBackgroundColor: '#00c0ef',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.item_count_day,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日平均杯數',
          borderColor: '#dd4b39',
          pointBackgroundColor: '#dd4b39',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.item_count_day_mean,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日一般單杯數',
          borderColor: '#337ab7',
          pointBackgroundColor: '#337ab7',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.item_count_day_normal,
          yAxisID: 'y-axis-1'
        }, {
          label: '當日揪團單杯數',
          borderColor: '#605ca8',
          pointBackgroundColor: '#605ca8',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          data: this.transactions.item_count_day_group,
          yAxisID: 'y-axis-1'
        }]
        if (typeof transactionsOrderChart !== 'undefined') {
          transactionsOrderChart.destroy()
        }
        if (typeof transactionsMoneyChart !== 'undefined') {
          transactionsMoneyChart.destroy()
        }
        if (typeof transactionsAmountChart !== 'undefined') {
          transactionsAmountChart.destroy()
        }
        // order
        var ctx = document.getElementById('order-transactions').getContext('2d')
        var config = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        // money
        var ctx2 = document.getElementById('money-transactions').getContext('2d')
        var config2 = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas2
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        // money
        var ctx3 = document.getElementById('amount-transactions').getContext('2d')
        var config3 = {
          type: 'line',
          data: {
            labels: this.transactionLabels,
            datasets: datas3
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            },
            scales: {
              yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1'
              }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                  drawOnChartArea: false
                }
              }]
            }
          }
        }
        transactionsOrderChart = new Chart(ctx, config) // eslint-disable-line no-new
        transactionsMoneyChart = new Chart(ctx2, config2) // eslint-disable-line no-new
        transactionsAmountChart = new Chart(ctx3, config3) // eslint-disable-line no-new
      })
    },
    handelResize () {
      var self = this
      var w = $(window).innerWidth()
      if (w >= 1000) self.isMobile = false
      else self.isMobile = true
    },
    getMonthDay (date) {
      return moment(date, 'YYYY-MM-DD').format('MM/DD')
    }
  },
  beforeDestory () {
    $(window).off('resize')
  },
  mounted () {
    var self = this
    this.handelResize()
    $(window).resize(function () {
      self.handelResize()
    })
    this.$nextTick(function () {
      if (!self.isMobile) {
        /*
        $('#today-shopper').attr('height', 80)
        $('#total-shopper').attr('height', 80)
        $('#shopper-active').attr('height', 80)
        $('#order-transactions').attr('height', 100)
        $('#money-transactions').attr('height', 100)
        $('#amount-transactions').attr('height', 100)
        $('#order-transactions-accum').attr('height', 100)
        $('#money-transactions-accum').attr('height', 100)
        $('#amount-transactions-accum').attr('height', 100)
        */
        $('#rejected-orders').attr('height', 80)
        // $('#product-sale').attr('height', 80)
      }
    })
  },
  watch: {
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('31', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days'),
          to: moment(this.menuTime.end.time).add(1, 'days')
        }
      ]
    },
    brandSelect () {
      this.storeSelect = 0
      if (this.brandSelect !== 0 && this.brandSelect !== '0') {
        this.getStoreBrief(this.brandSelect)
        this.getShopperActivity('brand', this.brandSelect)
      } else {
        this.getShopperActivity()
        this.productSaleList = []
      }
    },
    storeSelect () {
      if (this.storeSelect !== 0 && this.storeSelect !== '0') this.getShopperActivity('store', this.storeSelect)
      else this.getShopperActivity('brand', this.brandSelect)
    }
  }
}
</script>
<style lang="sass" scope>
@media screen and (max-width: 767px)
  .box-title
    text-align: center
    width: 100%
</style>



// WEBPACK FOOTER //
// SystemChart.vue?995d4fe8